module.exports = __webpack_public_path__ + "static/media/Contactlivechat.4a084d04.svg";